module.exports = "/assets/bd028e505b5c41280cde76573f489c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KX.png
// module id = 1561
// module chunks = 0